module.exports = __webpack_public_path__ + "static/media/sliderImage4.39960145.png";